var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCseLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_32",
    "data-name": "Group 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126.742,
    height: 58.12,
    viewBox: "0 0 126.742 58.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #ff9017;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1",
    width: 126.742,
    height: 58.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-3",
    d: "M55.939,22.433,44.825,3.09A6.065,6.065,0,0,0,39.579.047L17.271,0a6.064,6.064,0,0,0-5.259,3.022L.819,22.317a6.061,6.061,0,0,0-.012,6.066C3.643,33.31,9.143,42.859,11.953,47.738a6.063,6.063,0,0,0,5.24,3.036l12.524.03a6.065,6.065,0,0,1,5.255,3.062l2.075,3.642a1.213,1.213,0,0,0,2.1.006c3.147-5.446,12.5-21.626,16.78-29.024a6.061,6.061,0,0,0,.008-6.058M47.66,27.312,38.418,43.144l-8.4-14.7a6.066,6.066,0,0,1,.024-6.057,6.063,6.063,0,0,1-5.262,3L7.853,25.3,17.1,9.47a3.641,3.641,0,0,1,3.161-1.8l18.332.087h0l9.09,15.919a3.639,3.639,0,0,1-.017,3.639",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M288.756,39.432v-.027a4.823,4.823,0,0,1,4.949-4.882,4.6,4.6,0,0,1,3.983,1.958L295.73,38a2.513,2.513,0,0,0-2.052-1.1,2.322,2.322,0,0,0-2.24,2.481v.027a2.322,2.322,0,0,0,2.24,2.508,2.564,2.564,0,0,0,2.119-1.14l1.958,1.395a4.943,4.943,0,0,1-9-2.736",
    transform: "translate(-224.345 -26.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M334.994,35.365h4.439a4.1,4.1,0,0,1,3.058,1.019,2.911,2.911,0,0,1,.832,2.186V38.6a2.969,2.969,0,0,1-1.931,2.884l2.24,3.273h-3l-1.891-2.843H337.6v2.843h-2.6Zm4.319,4.507c.885,0,1.4-.429,1.4-1.113v-.027c0-.738-.537-1.113-1.408-1.113h-1.7v2.253Z",
    transform: "translate(-260.269 -27.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M377.343,41.239l-3.568-5.875h2.964l1.931,3.42,1.945-3.42h2.911L379.958,41.2v3.554h-2.615Z",
    transform: "translate(-290.399 -27.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M423.2,35.364h4.024c2.374,0,3.9,1.221,3.9,3.3v.027c0,2.213-1.7,3.38-4.037,3.38H425.8v2.682h-2.6Zm3.836,4.668c.925,0,1.489-.483,1.489-1.221v-.027c0-.8-.563-1.234-1.5-1.234H425.8v2.481Z",
    transform: "translate(-328.8 -27.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M465.039,37.645h-2.817v-2.28h8.235v2.28h-2.817v7.109h-2.6Z",
    transform: "translate(-359.117 -27.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M501.906,39.432v-.027a5.06,5.06,0,0,1,10.113-.027v.027a5.06,5.06,0,0,1-10.113.027m7.457,0v-.027a2.44,2.44,0,0,0-2.414-2.535,2.393,2.393,0,0,0-2.374,2.508v.027a2.437,2.437,0,0,0,2.4,2.535,2.4,2.4,0,0,0,2.388-2.508",
    transform: "translate(-389.949 -26.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M288.756,100.743l1.449-1.73a4.836,4.836,0,0,0,3.045,1.127c.7,0,1.073-.241,1.073-.644v-.027c0-.389-.309-.6-1.583-.9-2-.456-3.541-1.019-3.541-2.951v-.027c0-1.744,1.382-3,3.635-3a5.909,5.909,0,0,1,3.863,1.247l-1.3,1.837a4.71,4.71,0,0,0-2.629-.925c-.63,0-.939.268-.939.6v.027c0,.429.322.617,1.623.912,2.159.47,3.5,1.167,3.5,2.924v.027c0,1.918-1.516,3.058-3.8,3.058a6.558,6.558,0,0,1-4.4-1.556",
    transform: "translate(-224.345 -71.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M331.775,93.009h2.508l4,9.456h-2.79l-.684-1.676h-3.621l-.671,1.676h-2.736Zm2.28,5.754-1.046-2.669-1.06,2.669Z",
    transform: "translate(-254.663 -72.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M368.064,93.31h2.911l2.133,5.942,2.132-5.942H378.1l-3.809,9.456h-2.414Z",
    transform: "translate(-285.962 -72.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    width: 2.615,
    height: 9.389,
    transform: "translate(93.569 20.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M441,93.31h2.428l3.863,4.963V93.31h2.575V102.7h-2.28l-4.01-5.15v5.15H441Z",
    transform: "translate(-342.627 -72.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M487.656,97.377V97.35a4.874,4.874,0,0,1,5.056-4.882,5.476,5.476,0,0,1,3.809,1.368l-1.529,1.838a3.312,3.312,0,0,0-2.266-.885,2.466,2.466,0,0,0-2.4,2.575v.027a2.48,2.48,0,0,0,2.549,2.6,2.652,2.652,0,0,0,1.5-.389v-1.14h-1.851v-1.9h4.319v4.225a6.349,6.349,0,0,1-4.077,1.448,4.827,4.827,0,0,1-5.11-4.855",
    transform: "translate(-378.877 -71.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M288.756,151.321h7.551v2.213h-4.976v1.422h4.507v2.052h-4.507V158.5h5.043v2.213h-7.618Z",
    transform: "translate(-224.345 -117.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M332.32,155.935l-3.085-4.614h2.991l1.663,2.642,1.677-2.642h2.924l-3.085,4.587,3.219,4.8h-2.991l-1.8-2.83-1.811,2.83H329.1Z",
    transform: "translate(-255.691 -117.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M378.285,151.321h4.024c2.374,0,3.9,1.221,3.9,3.3v.027c0,2.213-1.7,3.38-4.037,3.38h-1.288v2.682h-2.6Zm3.836,4.667c.925,0,1.489-.483,1.489-1.221v-.027c0-.8-.563-1.234-1.5-1.234h-1.221v2.481Z",
    transform: "translate(-293.903 -117.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-1",
    d: "M420.855,151.321h7.551v2.213H423.43v1.422h4.506v2.052H423.43V158.5h5.043v2.213h-7.618Z",
    transform: "translate(-326.978 -117.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-1",
    d: "M463.064,151.321h4.44a4.1,4.1,0,0,1,3.058,1.019,2.912,2.912,0,0,1,.832,2.186v.027a2.969,2.969,0,0,1-1.932,2.884l2.24,3.273h-3l-1.891-2.843h-1.14v2.843h-2.6Zm4.319,4.507c.885,0,1.395-.429,1.395-1.113v-.027c0-.738-.536-1.113-1.408-1.113h-1.7v2.253Z",
    transform: "translate(-359.771 -117.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M508.872,153.6h-2.816v-2.28h8.235v2.28h-2.817v7.109h-2.6Z",
    transform: "translate(-393.173 -117.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M554.764,11.253l-.609-.864h-.545v.864h-.436V8.774h1.1c.57,0,.92.3.92.786a.743.743,0,0,1-.591.754l.669.938Zm-.52-2.082h-.634V10h.637c.312,0,.51-.163.51-.418,0-.273-.191-.414-.513-.414",
    transform: "translate(-429.781 -6.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M549.578,8.529a2.336,2.336,0,1,1,2.336-2.336,2.339,2.339,0,0,1-2.336,2.336m0-4.309a1.973,1.973,0,1,0,1.973,1.973,1.975,1.975,0,0,0-1.973-1.973",
    transform: "translate(-425.172 -2.997)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCseLogoLight);
export default __webpack_public_path__ + "static/media/cse_logo_light.2c50630e38a460dd9ed70c939ae1478c.svg";
export { ForwardRef as ReactComponent };